export default __webpack_public_path__ + "static/media/icon-products.9b27a55d.svg";